module.exports = __webpack_public_path__ + "static/media/496.904a2c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/496.png
// module id = 761
// module chunks = 0